import { Chat,  Send } from '@mui/icons-material'
import { TextField } from '@mui/material'
import { CgMinimizeAlt } from 'react-icons/cg'
import { WSChatMessage } from 'mvppoker-portal-common/api'
import { MVPButton } from 'mvppoker-portal-common/components'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { LobbyChatListItem } from './LobbyChatListItem'
import { useLobbyChat, useLobbyStats, useOtherProfilesLookup } from '../../../state/hooks/ProfileDataHooks'
import { useUsersOnline } from '../../../state/hooks/AppConfigHooks'
import { websocketConnection } from '../../../logic/websockets/Websockets'
import { useActiveUser } from '../../../state/hooks/ActiveUserHooks'
import './LobbyChatView.scss'

const ADDED_COUNT = 3

export const LobbyChatView : React.FC<{}> = ({ }) =>
{
	const user = useActiveUser()?.user
	const usersOnline = useUsersOnline()
	const { lobbyChat, updateLobbyChat } = useLobbyChat()
	const { lobbyStats } = useLobbyStats()
	const otherProfiles = useOtherProfilesLookup()
	const [isMinimized, setMinimized] = useState(false)
	const [inputText, setInputText] = useState('')

	const userId = user?.id
	const userAvatar = user?.info.avatar

	//  TODO: work out how to reset the lobby chat when going back from a game

	const clickMinimizeButton = () => {
		setMinimized((prev) => !prev)
	}

	const onClickSend = () : void => {
		if (userId && inputText.length > 0){
			const m : WSChatMessage = {
				fromId: userId,
				toId: 'lobby',
				message: inputText,
				timestamp: Date.now()
			}
			websocketConnection.sendLobbyChat(m)
		}
		setInputText('')
	}

	const usersOnlineInfo = useMemo(() => {
		return `Users Online: ${usersOnline + ADDED_COUNT}`
	}, [usersOnline])

	const usersLobbyInfo = useMemo(() => {
		return `Users In Lobby: ${lobbyStats.usersCount + ADDED_COUNT}`
	}, [lobbyStats])
	
	const items = useMemo(() => {
		if (userId && userAvatar){
			return lobbyChat.map((message) => <LobbyChatListItem key={message.timestamp} userId={userId} userAvatar={userAvatar} senderProfile={otherProfiles[message.fromId]} chatMessage={message}  />)
		}
	}, [userId, lobbyChat])

	const messagesEndRef = useRef<null | HTMLDivElement>(null)
	const scrollToBottom = () => {
		messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' })
	}
	useEffect(() => {
		scrollToBottom()
	}, [items])

	const minimizedView = useMemo(() => {
		return <div id='lobby-chat-minimized' onClick={clickMinimizeButton}>
			<h3 id='lobby-chat-minimzed-info-online'>{usersOnlineInfo}</h3>
			<h3 id='lobby-chat-minimzed-info-lobby'>{usersLobbyInfo}</h3>
			<Chat id='lobby-chat-minimized-image'/>
		</div>
	}, [])


	return (
		<div id='lobby-chat'>
			{isMinimized && minimizedView}
			{!isMinimized && 
				<div id="lobby-chat-main">
					<div id='header'>
						<h2>LOBBY CHAT</h2>
						<h3>{usersOnlineInfo} | {usersLobbyInfo}</h3>
						<CgMinimizeAlt id='lobby-chat-main-minimized-image' onClick={clickMinimizeButton}/>
					</div>
					<div id='lobby-chat-list'>
						{items}
						<div ref={messagesEndRef} />
					</div>
					<div id='send-message-container'>
						<TextField
							id='send-message-field'
							variant='filled'
							label='Message'
							value={inputText}
							onChange={e => setInputText(e.target.value)}
							onKeyUp={e => e.key === 'Enter' && onClickSend()}
						/>
						<MVPButton id='send-message-button' onClick={onClickSend} >
							<Send />
							SEND
						</MVPButton>
					</div>
				</div>
			}
		</div>
	)
}
